import { render, staticRenderFns } from "./DeviceDimensionsForm.vue?vue&type=template&id=9427652c"
import script from "./DeviceDimensionsForm.vue?vue&type=script&lang=ts"
export * from "./DeviceDimensionsForm.vue?vue&type=script&lang=ts"
import style0 from "./DeviceDimensionsForm.vue?vue&type=style&index=0&id=9427652c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports